import { defineStore } from "pinia";
import { Session } from "@/features/Authentication/SessionService";
import { AuthorizationData } from "@/features/Authentication/PlatformUserInfoService";

interface UserStore {
    user?: Session;
    postLoginRoute: string;
    referrer: string;
}

interface AuthorizationStore {
    authorizationData?: AuthorizationData;
}

export const useUserStore = defineStore("user", {
    state: (): UserStore => {
        return {
            postLoginRoute: "/",
            referrer: "",
        };
    },
    getters: {
        loggedIn(): boolean {
            return this.user !== undefined;
        },
    },
    actions: {
        storeUser(user: Session) {
            this.user = user;
        },

        clearUser() {
            this.user = undefined;
        },

        getUser(): Session | undefined {
            return this.user;
        },

        storePostLoginRoute(route: string) {
            this.postLoginRoute = route;
        },

        getPostLoginRoute(): string {
            return this.postLoginRoute;
        },

        getReferrer(): string {
            return this.referrer;
        },

        storeReferrer(path: string) {
            this.referrer = path;
        },
    },
});

export const useAuthStore = defineStore("authorization", {
    state: (): AuthorizationStore => {
        return {};
    },
    getters: {
        authorizationDataLoaded(): boolean {
            return this.authorizationData !== undefined;
        },
    },
    actions: {
        storeAuthorizationData(data: AuthorizationData) {
            this.authorizationData = data;
        },
    },
});
